import { Route, Routes } from 'react-router-dom'
import Admin from './index'

export const adminRoutes = {
  subdomain: 'admin',
  routes: () => (
    <Routes>
      <Route path='/' element={<Admin />} />
    </Routes>
  ),
}
